import debug from 'debug';
import { beginTask, endTask } from 'redux-nprogress';

import * as types from './tracking.types';

const log = debug('huddle:store:actions:tracking');

export const getSinglePlayer = id => async (dispatch, getState, { api }) => {
  try {
    const { player } = await api.players.playerDescription({ id });
    dispatch({
      type: types.TRACK_SET_PLAYER_DATA,
      payload: {
        id,
        player,
      },
    });
  } catch (error) {
    log('Error retrieving player: ', error);
  }
};

export const getTracking = async (dispatch, getState, { api }) => {
  dispatch(beginTask());

  log('Retrieving tracking');
  dispatch({ type: types.TRACK_GET });

  try {
    const { tracking } = await api.tracking.getAll();

    return dispatch({
      type: types.TRACK_GOT,
      payload: {
        tracking,
      },
    });
  } catch (error) {
    log('Error from call to api.tracking.getTracking:', error);
    return dispatch({
      type: types.TRACK_ERROR,
      error,
    });
  } finally {
    // end NProgress bar task
    dispatch(endTask());
  }
};

// using this to attach id to the response, which the API doesn't do
const putHelper = async (api, id, leagues) => {
  const { tracking } = await api.tracking.putTracking(id, leagues);
  return ({ id, tracking });
};

export const addTracking = toAdd => async (dispatch, getState, { api }) => {
  // expects an array of format [{player_id, formula_ids:[]}]
  const { tracking } = await api.tracking.postTracking(toAdd);
  tracking.forEach(({ player_id, formula_ids }) =>
    dispatch({ type: types.TRACK_ADD, payload: { id: player_id, leagues: formula_ids } }));
};

export const changeTracking = toChange => async (dispatch, getState, { api }) => {
  // expects an array of format [{player_id, formula_ids:[]}]
  const resp = await Promise.all(
    toChange.map(({ player_id, ...leagues }) =>
      putHelper(api, player_id, leagues)));
  resp.forEach(({ id, tracking }) =>
    dispatch({ type: types.TRACK_CHANGE, payload: { id, leagues: tracking.formula_ids } }));
};

export const deleteTracking = toDelete => async (dispatch, getState, { api }) => {
  // expects an array of player_ids to delete
  
  const resp = await Promise.all(toDelete.map(id => api.tracking.deleteTracking(id)));
  
  resp.forEach(({ tracked_player_id }) =>
    dispatch({ 
      type: types.TRACK_DELETE, 
      payload: { id: tracked_player_id.id },
       }));
};

export const deleteLeagueTracking = toDelete => async (dispatch, getState, { api }) => {
  // expects an array of format [{formula_ids:[]}]
  const resp = await Promise.all(toDelete.map(({ player_id, formula_ids }) =>
    api.tracking.deleteLeagueTracking(player_id, formula_ids)));
};

export const batchTracking = (doTrack, dontTrack) => async (dispatch, getState) => {
  dispatch(beginTask());
  dispatch({ type: types.TRACK_BEGIN_UPDATE });
  const { ...oldTrack } = getState().tracking.tracking;
  const keepTrack = [];
  const loseTrack = [];

  dontTrack.forEach(id => delete oldTrack[id]); // remove to-be-deleted keys

  Object.keys(doTrack).forEach(id => {
    loseTrack.push(id);
    keepTrack.push({ player_id: id, formula_ids: doTrack[id].leagues });
  });
  try {
    await Promise.all([
      dontTrack.length && dispatch(deleteTracking(dontTrack))]);
    await Promise.all([
      loseTrack.length && dispatch(deleteTracking(loseTrack))]);
    await Promise.all([
      keepTrack.length && dispatch(addTracking(keepTrack))]);

  } catch (error) {
    dispatch({ type: types.TRACK_UPDATE_ERROR, payload: error });
    log(`Error: ${error}`);
  } finally {
    dispatch({ type: types.TRACK_END_UPDATE });
    dispatch(endTask());
  }
};




// WEBPACK FOOTER //
// ./src/store/actions/tracking.actions.js